<div class="layout-footer">
    <!-- <img src="assets/layout/images/DOW_&_JV_Logo.png" alt="Logo" height="20" class="mr-2"/> -->
    <small>Copyright © The Dow Chemical Company (1995-2017). All Rights Reserved. ®™* Trademark of The Dow Chemical Company ("Dow") or an affiliated company of Dow</small>
</div>
